<template>
  <div class="card p-4 shadow-sm">
    <div class="container-fluid my-4">
      <h3 class="text-center mb-4">Reducir Fecha de Salida</h3>

      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Código de Reserva</label>
          <input type="text" class="form-control" :value="'R00' + reserva?.IdReserva" readonly />
        </div>
        <div class="col-md-6">
          <label class="form-label">Cliente</label>
          <input type="text" class="form-control" :value="reserva?.huesped?.Nombre + ' ' + reserva?.huesped?.Apellido" readonly />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Fecha de Llegada</label>
          <input type="text" class="form-control" :value="formatearFecha(reserva?.FechaLlegada)" readonly />
        </div>
        <div class="col-md-6">
          <label class="form-label">Fecha de Salida Actual</label>
          <input type="text" class="form-control" :value="formatearFecha(reserva?.FechaSalida)" readonly />
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label d-flex align-items-center">
          Nueva Fecha de Salida
          <span class="tooltip-icon ms-2">?
            <span class="tooltip-text">
              Seleccione una fecha entre la fecha de llegada y un día antes de la salida, para poder actualizar.
            </span>
          </span>
        </label>

        <input 
          type="date" 
          class="form-control" 
          v-model="nuevaFecha"
          :min="fechaMin" 
          :max="fechaMax"
        />
      </div>
      <div v-if="esReservaDeUnDia" class="alert alert-warning mt-2">
        Esta reserva es de solo un día y no se puede reducir.
      </div>

      <div class="text-end">
        <button class="btn btn-primary" @click="guardarCambios" :disabled="esReservaDeUnDia">
          Guardar Cambios
        </button>
      </div>
    </div>

    <!-- Toast -->
    <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
      <div v-if="mostrarToast" class="toast show text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Modal de Monto a Devolver -->
    <div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="modalDevolucionVisible" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white shadow">
          <div class="modal-header">
            <h5 class="modal-title">Monto a Devolver</h5>
            <button type="button" class="btn-close" @click="cerrarModalDevolucion"></button>
          </div>
          <div class="modal-body">
            <p>Se debe devolver <strong>Q.{{ Number(montoDevolucion).toFixed(2) }}</strong> al cliente.</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="cerrarModalDevolucion">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'ReducirReserva',
  data() {
    return {
      reserva: null,
      nuevaFecha: '',
      alerta: { mensaje: '', tipo: 'success' },
      mostrarToast: false,
      modalDevolucionVisible: false,
      montoDevolucion: null
    }
  },
  computed: {
    fechaMin() {
      if (!this.reserva?.FechaLlegada) return '';
      const fecha = new Date(this.reserva.FechaLlegada);
      return fecha.toISOString().split('T')[0];
    },
    fechaMax() {
      if (!this.reserva?.FechaSalida) return '';
      const fecha = new Date(this.reserva.FechaSalida);
      fecha.setDate(fecha.getDate() - 1);
      return fecha.toISOString().split('T')[0];
    },
    esReservaDeUnDia() {
      if (!this.reserva?.FechaLlegada || !this.reserva?.FechaSalida) return false;
      const llegada = new Date(this.reserva.FechaLlegada);
      const salida = new Date(this.reserva.FechaSalida);
      const diff = (salida - llegada) / (1000 * 60 * 60 * 24);
      return diff <= 1;
    },
    toastColor() {
      return {
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning text-dark',
        info: 'bg-info text-dark'
      }[this.alerta.tipo] || 'bg-primary';
    },
    iconoToast() {
      return {
        success: 'bi bi-check-circle-fill',
        danger: 'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info: 'bi bi-info-circle-fill'
      }[this.alerta.tipo] || 'bi bi-info-circle-fill';
    }
  },
  mounted() {
    const id = this.$route.params.id;
    this.obtenerReserva(id);
  },
  methods: {
    async obtenerReserva(id) {
      try {
        const res = await axios.get(`${API_URL}/reservas/${id}`);
        this.reserva = res.data.reserva;
        this.nuevaFecha = this.formatearFecha(res.data.reserva.FechaSalida);
      } catch (error) {
        console.error('Error al obtener reserva:', error);
      }
    },
    async guardarCambios() {
      if (!this.nuevaFecha) {
        this.mostrarToastMensaje('Seleccione una nueva fecha de salida', 'warning');
        return;
      }
      try {
        const id = this.reserva.IdReserva;
        const res = await axios.put(`${API_URL}/reserva/${id}/reducir-fecha`, {
          nueva_fecha_salida: this.nuevaFecha
        });
        this.mostrarToastMensaje(res.data.message, 'success');

        if (res.data.monto_a_devolver != null) {
          this.montoDevolucion = res.data.monto_a_devolver;
          this.modalDevolucionVisible = true;
        } else {
          setTimeout(() => {
    this.$router.push('/reducir-reservas-admin');
  }, 3000);
        }
      } catch (error) {
        console.error('Error al actualizar reserva:', error);
        this.mostrarToastMensaje('Error al actualizar reserva', 'danger');
      }
    },
    formatearFecha(fecha) {
      const dateObj = new Date(fecha);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    mostrarToastMensaje(mensaje, tipo = 'success') {
      this.alerta.mensaje = mensaje;
      this.alerta.tipo = tipo;
      this.mostrarToast = true;
      setTimeout(() => {
        this.mostrarToast = false;
      }, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
    cerrarModalDevolucion() {
      this.modalDevolucionVisible = false;
      this.$router.push('/reducir-reservas-admin');
    }
  }
}
</script>

<style scoped>
input[readonly] {
  background-color: #f5f5f5;
}

.tooltip-icon {
  position: relative;
  display: inline-block;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  cursor: pointer;
}

.tooltip-text {
  visibility: hidden;
  width: 220px;
  background-color: #333;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-icon:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
